import { memo } from 'react';

import { Typography } from '@mui/material';

import { formatNumber } from '@/shared/lib/format';

import { DATE_NUMBER_CELL_SX } from './cells.styles';

export interface NumberCellProps {
  value: number | null | undefined;
}

export const NumberCell = memo(({ value }: NumberCellProps) => (
  <Typography variant="body2" sx={DATE_NUMBER_CELL_SX}>
    {formatNumber(value)}
  </Typography>
));
NumberCell.displayName = 'NumberCell';
